import { tarifPersonnalisation } from './boutiqueClubPersonnalisationUtils';

export const SPORTS_BOUTIQUE = ['Football', 'Basket', 'Handball', 'Rugby', 'Volley', 'Running', 'Autre'];

export function sportBoutique(sport) {
  const texte = String(sport || '').toLowerCase();
  return SPORTS_BOUTIQUE.find((nom) => texte.includes(nom.toLowerCase())) || 'Autre';
}

export function modificationTaille(taille) {
  const libelle = String(taille.libelle || '').trim();
  const illimite = !!taille.quota_illimite;
  const quota = Number(taille.quota);
  if (!libelle || (!illimite && (String(taille.quota).trim() === '' || !Number.isSafeInteger(quota) || quota < 0))) {
    throw new Error('Saisissez une taille et un quota entier positif ou nul.');
  }
  const resultat = { libelle, quota: illimite ? 0 : quota };
  if (Object.prototype.hasOwnProperty.call(taille, 'quota_illimite')) resultat.quota_illimite = illimite;
  return resultat;
}

// Liste blanche : aucune donnée contractuelle ou de coût dans la vue adhérent.
export function produitAdherent(p) {
  const interclub = String(p.source_origine || '').toUpperCase() === 'INTERCLUB';
  const reference = p.prix_reference_ttc ?? (p.est_pack ? p.prix_boutique_ttc : null) ?? p.prix_adherent_retenu_ttc ?? (interclub ? null : p.prix_adherent_ttc);
  const netExplicite = Object.prototype.hasOwnProperty.call(p, 'prix_net_ttc');
  const net = netExplicite ? p.prix_net_ttc : p.prix_boutique_ttc;
  const aUnNet = netExplicite || net != null;
  const montantValide = valeur => ['number','string'].includes(typeof valeur) && String(valeur).trim() !== '' && Number.isFinite(Number(valeur)) && Number(valeur) >= 0;
  const promoRetenue = p.prix_promo_retenu_ttc ?? (interclub ? null : p.prix_promo_ttc);
  // Le net serveur prime les promotions historiques. Un net explicite invalide
  // bloque l'article ; il ne sélectionne jamais silencieusement un autre montant.
  const prixValide = montantValide(reference) && (!aUnNet || montantValide(net));
  const prix = !prixValide ? null : (aUnNet && (Number(net) >= Number(reference) || Number(net) === 0) ? net : reference);
  const promo = aUnNet ? net : promoRetenue;
  return {
    id: p.id, reference:p.reference, famille_id: p.famille_id,
    nom: String(p.designation_boutique || '').trim() || p.designation,
    marque: marqueProduit(p),
    couleur: couleurProduit(p), description: p.texte_presentation,
    photo: p.photo_principale_path,
    prix, promo: prixValide && montantValide(promo) && Number(promo) > 0 && Number(promo) < Number(prix) ? promo : null,
    prix_brut: montantValide(p.prix_brut_ttc) ? Number(p.prix_brut_ttc) : null,
    visible: p.visible, pack: p.est_pack, personnalisable: p.personnalisable,
    cb: p.paiement_cb !== false, bon: !!p.bon_achat_club,
    personnalisations: (Array.isArray(p.personnalisation_config) ? p.personnalisation_config : []).filter((o) => o.actif),
    groupes_choix_pack: Array.isArray(p.groupes_choix_pack) ? p.groupes_choix_pack : null,
    prix_variable: !!p.prix_variable,
    pictogramme_codes: Array.isArray(p.pictogramme_codes) ? [...p.pictogramme_codes] : [],
    options: (Array.isArray(p.options_boutique) ? p.options_boutique : []).filter((o) => o.actif !== false).map((o) => ({
      id: o.id, libelle: o.libelle, prix_ttc: o.prix_ttc, saisie_requise: !!o.saisie_requise,
    })),
  };
}

export function marqueProduit(produit = {}) {
  return String(produit.marque || produit.source_snapshot?.marque || '').trim();
}

export function designationAvecMarque(produit = {}, designationForcee) {
  const designation = String(designationForcee ?? produit.designation_boutique ?? produit.designation ?? produit.nom ?? '').trim();
  const marque = marqueProduit(produit);
  return marque ? `${designation} - ${marque}` : designation;
}

export function couleurProduit(produit = {}) {
  const explicite = String(produit.couleur || produit.source_snapshot?.couleur || '').trim();
  if (explicite) return explicite;
  // Les références du devis Cousinade portent déjà la couleur après le code
  // article (ex. « IB321 ROSE »). On l'affiche sans modifier la fiche source.
  const reference = String(produit.reference || '').trim();
  const morceaux = reference.split(/\s+/).filter(Boolean);
  return morceaux.length > 1 ? morceaux.slice(1).join(' ') : '';
}

export function optionsBoutiqueSansDoublons(produit = {}, champs = []) {
  const cle = (valeur) => String(valeur || '').trim().toLocaleLowerCase('fr');
  const clesChamps = new Set((Array.isArray(champs) ? champs : []).flatMap((champ) => [champ.id, champ.type, champ.libelle]).map(cle).filter(Boolean));
  return (Array.isArray(produit.options) ? produit.options : []).filter((option) => ![option.id, option.libelle].map(cle).some((valeur) => valeur && clesChamps.has(valeur)));
}

export function champsPersonnalisationProduit(produit = {}, optionsServeur = []) {
  const personnalisationsHistoriques = Array.isArray(produit.personnalisations) ? produit.personnalisations : [];
  const optionsModernes = (Array.isArray(optionsServeur) ? optionsServeur : [])
    .filter((option) => option?.produit_id === produit.id && option.actif !== false)
  const modernes = optionsModernes.map((option) => {
    const typeMetier = String(option.type || '').trim().toUpperCase();
    // Le moteur transactionnel historique valide encore les options de ligne
    // avec personnalisation_config. Conserver l'UUID moderne pour l'interface,
    // mais transmettre le type historique équivalent quand il est sans ambiguïté.
    const typesCompatibles = typeMetier === 'TEXTE' ? ['NOM'] : [];
    const correspondances = personnalisationsHistoriques.filter((historique) =>
      historique?.actif !== false && typesCompatibles.includes(String(historique.type || '').trim().toUpperCase())
    );
    return {
      id: option.id,
      type: option.id,
      type_metier: option.type,
      ...(correspondances.length === 1 ? { type_serveur: correspondances[0].type } : {}),
      libelle: option.libelle,
      max: Number(option.longueur_max || 50),
      chiffres_uniquement: option.type === 'NUMERO',
      actif: !!option.obligatoire,
      obligatoire: !!option.obligatoire,
      valeur_min: option.valeur_min,
      valeur_max: option.valeur_max,
      mode_tarification: option.mode_tarification,
      prix_individuel_ttc: option.prix_individuel_ttc,
      groupe_tarifaire_id: option.groupe_tarifaire_id,
      source: 'CONFIGURATION',
    };
  });
  const typesModernes = new Set(optionsModernes.map((option) => String(option.type || '').trim().toUpperCase()).filter(Boolean));
  // L'ancien champ NOM et une option TEXTE moderne décrivent la même saisie
  // adhérent. Conserver la donnée historique, mais ne pas afficher un second
  // champ sans calque graphique dès que le nouveau moteur est configuré.
  if (typesModernes.has('TEXTE')) typesModernes.add('NOM');
  if (typesModernes.has('NUMERO')) {
    typesModernes.add('NUMERO_DOS');
    typesModernes.add('NUMERO_COEUR');
  }
  const libellesModernes = new Set(optionsModernes.map((option) => String(option.libelle || '').trim().toLocaleLowerCase('fr')).filter(Boolean));
  const historiques = (Array.isArray(produit.personnalisations) ? produit.personnalisations : [])
    .filter((option) => option?.actif !== false
      && !typesModernes.has(String(option.type || '').trim().toUpperCase())
      && !libellesModernes.has(String(option.libelle || '').trim().toLocaleLowerCase('fr')))
    .map((option) => ({ ...option, source: 'HISTORIQUE' }));
  return [...modernes, ...historiques];
}

export function aideChampPersonnalisation(option = {}) {
  const type = String(option.type || '').toUpperCase();
  const libelle = String(option.libelle || 'Personnalisation').trim();
  const instructions = {
    NOM: 'Saisissez le nom à inscrire sur l’article.',
    NUMERO: 'Saisissez le numéro à inscrire sur l’article.',
    NUMERO_DOS: 'Saisissez le numéro à inscrire au dos de l’article.',
    NUMERO_COEUR: 'Saisissez le numéro à inscrire côté cœur.',
    AUTRE: 'Décrivez précisément la personnalisation souhaitée.',
  };
  const maxBrut = Number(option.max ?? option.longueur_max ?? 50);
  const max = Number.isSafeInteger(maxBrut) && maxBrut > 0 ? maxBrut : 50;
  return {
    instruction: instructions[type] || `Saisissez la valeur attendue pour « ${libelle} ».`,
    obligation: option.actif ? 'Obligatoire' : 'Facultatif',
    max,
  };
}

export function erreurBoutique(error, contexte = 'Enregistrement impossible. Réessayez ou contactez votre administrateur.') {
  console.error('BoutiqueClub', error);
  const technique = String(error?.message || error || '');
  if (technique.includes('boutiqueclub_campagnes_check1') || technique.includes('boutiqueclub_campagnes_lieu_retrait_check')) return 'Choisissez un lieu de retrait avant de créer la campagne.';
  if (technique === 'Une ligne utilisée dans BoutiqueClub ne peut pas être supprimée du devis.') return technique;
  if (technique.includes('boutiqueclub_campagnes_check')) return 'Vérifiez les dates : la fermeture doit suivre l’ouverture et la livraison doit suivre la fermeture.';
  if (technique.includes('boutiqueclub_produits_devis_ligne_source_id_fkey')) return 'Ce devis est utilisé dans une boutique. Ses lignes doivent être conservées lors de l’enregistrement ; contactez votre administrateur.';
  if (error?.code === '42501') return 'Vous ne disposez pas des droits nécessaires pour cette opération.';
  if (error?.code === '23505') return 'Cet élément existe déjà. Modifiez l’élément existant.';
  if (error?.code === '23503') return 'Cet élément est utilisé ailleurs ou sa référence est introuvable. Vérifiez les éléments associés.';
  if (error?.code === 'PGRST204' || error?.code === '42703') return 'Cette fonction nécessite la mise à jour de la base BoutiqueClub. Aucune donnée n’a été enregistrée.';
  return contexte;
}

export function verifierCampagne(c, points = [], magasins = []) {
  const ouverture = new Date(c.ouverture_at).getTime();
  const fermeture = new Date(c.fermeture_at).getTime();
  if (!Number.isFinite(ouverture) || !Number.isFinite(fermeture) || fermeture <= ouverture) return 'La fermeture doit être postérieure à l’ouverture. Vérifiez les dates et les heures.';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(c.livraison_prevue || '') || c.livraison_prevue < dateLocale(c.fermeture_at).slice(0, 10)) return 'La livraison prévue doit suivre la date de fermeture.';
  const magasin = magasins.find((m) => String(m.id) === String(c.magasin_retrait_id) && String(m.club_id) === String(c.club_id));
  const statut = String(c.statut || 'BROUILLON').toUpperCase();
  const brouillon = ['BROUILLON', 'A_CONTROLER'].includes(statut);
  if (c.retrait_autorise && c.magasin_retrait_id && !magasin) return 'Choisissez un magasin CRM appartenant au Club.';
  if (c.retrait_autorise && magasin?.actif === false) return 'Choisissez un magasin CRM actif du Club.';
  if (c.retrait_autorise && magasin && !brouillon && (!String(magasin.nom||'').trim() || !String(magasin.adresse||'').trim() || !String(magasin.code_postal||'').trim() || !String(magasin.ville||'').trim())) return 'Complétez les coordonnées du magasin CRM avant publication.';
  if (c.retrait_autorise && !c.magasin_retrait_id && !String(c.lieu_retrait_libre || '').trim() && !points.some((p) => p.id === c.point_retrait_id && p.actif !== false)) return 'Choisissez un lieu de retrait : le magasin CRM unique de la campagne.';
  return '';
}

export function dateLocale(value) {
  const d = new Date(value);
  if (!Number.isFinite(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function tempsRestant(fermeture, now = Date.now()) {
  const fin = new Date(fermeture).getTime();
  if (!Number.isFinite(fin)) return null;
  const s = Math.max(0, Math.ceil((fin - now) / 1000));
  return { termine: s === 0, jours: Math.floor(s / 86400), heures: Math.floor(s / 3600) % 24, minutes: Math.floor(s / 60) % 60, secondes: s % 60 };
}

export function prixCentimes(p) {
  const prix = p.promo != null && p.prix != null && Number(p.promo) < Number(p.prix) ? p.promo : p.prix;
  if (prix == null || prix === '' || !Number.isFinite(Number(prix)) || Number(prix) < 0) return null;
  return Math.round(Number(prix) * 100);
}

export function modePaiementPack(pack) {
  if (pack?.paiement_cb === false && pack?.bon_achat_club) return 'BON';
  if (pack?.paiement_cb !== false && pack?.bon_achat_club) return 'CB_OU_BON';
  return 'CB';
}

export function prixPackBoutique(pack, produits = [], composants = []) {
  const somme = composants.filter((c) => c.pack_id === pack.id).reduce((total, c) => {
    const article = produits.find((p) => p.id === c.produit_composant_id);
    const interclub = String(article?.source_origine || '').toUpperCase() === 'INTERCLUB';
    const reference = article?.prix_adherent_retenu_ttc ?? (interclub ? null : article?.prix_adherent_ttc);
    return total + Number(c.quantite || 0) * Number(reference ?? 0);
  }, 0);
  if (pack.mode_prix_pack === 'PRIX_SPECIFIQUE') return { prix: Number(pack.prix_pack_specifique_ttc ?? somme), promo: null };
  if (pack.mode_prix_pack === 'PRIX_PROMOTIONNEL') return { prix: Number(pack.prix_pack_specifique_ttc ?? somme), promo: Number(pack.prix_pack_promo_ttc ?? somme) };
  const packCreeDansBoutique = pack?.source_snapshot?.type === 'PACK_BOUTIQUECLUB';
  return { prix: packCreeDansBoutique ? somme : Number(pack.prix_boutique_ttc ?? pack.prix_adherent_ttc ?? somme), promo: null };
}

// Préparation locale Flux 2 : aucune commande, réservation ou transaction serveur.
export function lignePanier({ campagne, produit, produits, composants, tailles, choix, options = {}, optionsComposants = {}, personnalisationsComposants = {}, groupesPersonnalisation = [], paiement, quantite = 1, panier = [], now = Date.now() }) {
  const temps = tempsRestant(campagne.fermeture_at, now);
  if (!temps || temps.termine) throw new Error('La campagne est terminée ou sa date de fermeture est invalide. Aucun ajout possible.');
  if (!Number.isSafeInteger(quantite) || quantite < 1 || quantite > 999) throw new Error('Choisissez une quantité entière entre 1 et 999.');
  const prix = prixCentimes(produit);
  if (prix == null) throw new Error('Le prix de cet article doit être précisé par le club.');
  const composition = produit.pack ? composants.filter((c) => c.pack_id === produit.id) : [{ id: produit.id, produit_composant_id: produit.id, quantite: 1 }];
  if (!composition.length) throw new Error('La composition de ce pack doit être précisée par le club.');
  let supplementComposants = 0;
  const articles = composition.map((c) => {
    const p = produits.find((x) => x.id === c.produit_composant_id);
    // Le portail public peut volontairement omettre l'id technique de la ligne
    // de composition. Utiliser alors l'article composant, stable et autorisé.
    const cle = produit.pack ? `${produit.id}-${c.id || c.produit_composant_id}` : produit.id;
    const t = tailles.find((x) => x.id === choix[cle] && x.produit_id === p?.id && x.actif);
    if (!p || !t) throw new Error('Sélectionnez la taille de chaque article avant l’ajout au panier.');
    if (!Number.isSafeInteger(Number(c.quantite)) || Number(c.quantite) < 1) throw new Error('La quantité d’un composant du pack doit être précisée par le club.');
    const q = quantite * Number(c.quantite);
    const reserve = panier.flatMap((l) => l.articles).filter((a) => a.taille_id === t.id).reduce((sum, a) => sum + a.quantite, 0);
    if (!t.quota_illimite && (!Number.isFinite(Number(t.quota)) || q + reserve > Number(t.quota))) throw new Error(`Quantité indisponible pour ${p.nom}, taille ${t.libelle}.`);
    const definitions = produit.pack ? (personnalisationsComposants[p.id] || []) : [];
    const valeurs = produit.pack ? (optionsComposants[p.id] || {}) : {};
    const saisies = definitions.map((definition) => {
      const texte = String(valeurs[definition.type]?.texte || valeurs[definition.id]?.texte || '').trim();
      const max = Number(definition.max ?? definition.longueur_max ?? 50);
      if ((definition.actif || definition.obligatoire) && !texte) throw new Error(`Renseignez le champ ${definition.libelle} pour ${p.nom}.`);
      if (texte && Number.isSafeInteger(max) && max > 0 && texte.length > max) throw new Error(`${definition.libelle} est limité à ${max} caractères pour ${p.nom}.`);
      if (texte && definition.chiffres_uniquement && !/^\d+$/.test(texte)) throw new Error(`${definition.libelle} doit contenir uniquement des chiffres pour ${p.nom}.`);
      return texte ? { option_id:definition.id, id:definition.id, libelle:definition.libelle, valeur:texte, texte } : null;
    }).filter(Boolean);
    const personnalisationsUnites = definitions.length ? Array.from({ length:q }, (_, index) => ({
      unite:index + 1,
      options:saisies.map(({ option_id, valeur }) => ({ option_id, valeur })),
    })) : [];
    const ids = saisies.map((saisie) => saisie.option_id);
    supplementComposants += Math.round(tarifPersonnalisation(definitions.map((definition)=>({ ...definition, actif:true })), groupesPersonnalisation, ids, q) * 100);
    return { produit_id: p.id, nom: p.nom, marque: p.marque || '', couleur: p.couleur || '', taille_id: t.id, taille: t.libelle, quantite: q,
      ...(personnalisationsUnites.length ? { personnalisations:saisies, personnalisations_unites:personnalisationsUnites } : {}) };
  });
  const selectionOptions = (produit.options || []).filter((o) => options[o.id]?.active).map((o) => {
    if (o.prix_ttc == null || o.prix_ttc === '' || !Number.isFinite(Number(o.prix_ttc)) || Number(o.prix_ttc) < 0) throw new Error('Le tarif de cette option doit être précisé par le club.');
    const texte = String(options[o.id]?.texte || '').trim();
    if (o.saisie_requise && !texte) throw new Error(`Renseignez le champ ${o.libelle}.`);
    return { id: o.id, libelle: o.libelle, texte, prix_centimes: Math.round(Number(o.prix_ttc) * 100) };
  });
  const personnalisations = (produit.personnalisations || []).map((o) => {
    const texte = String(options[o.type]?.texte || '').trim();
    if (o.actif && !texte) throw new Error(`Renseignez le champ ${o.libelle}. Ce champ est obligatoire pour personnaliser l’article.`);
    if (o.max && texte.length > Number(o.max)) throw new Error(`${o.libelle} est limité à ${o.max} caractères. Réduisez la saisie pour continuer.`);
    if (texte && o.chiffres_uniquement && !/^\d+$/.test(texte)) throw new Error(`${o.libelle} doit contenir uniquement des chiffres, sans espace ni symbole.`);
    return texte ? { id: o.type_serveur || o.type, option_id: o.id || o.type, libelle: o.libelle, texte, prix_centimes: 0 } : null;
  }).filter(Boolean);
  const personnalisationIds = (produit.personnalisations || [])
    .filter((o) => String(options[o.type]?.texte || '').trim())
    .map((o) => o.type);
  const supplementPersonnalisation = Math.round(tarifPersonnalisation(
    produit.personnalisations || [], groupesPersonnalisation, personnalisationIds, 1
  ) * 100);
  if (produit.pack && !((paiement === 'BON_CLUB' && produit.bon) || (paiement === 'CB' && produit.cb))) throw new Error('Choisissez un mode de paiement autorisé pour ce pack.');
  return { campagne_id: campagne.id, club_id: campagne.club_id, produit_id: produit.id, pack: produit.pack, nom: produit.nom, marque: produit.marque || '',
    quantite, articles, options: [...selectionOptions, ...personnalisations], paiement: produit.pack ? paiement : 'CB',
    // Le serveur reste l'autorité sur les cibles du Bon. Un article peut donc
    // proposer la saisie d'un Bon sans modifier son paramétrage de paiement CB.
    modes_autorises: produit.pack ? [...(produit.cb ? ['CB'] : []), ...(produit.bon ? ['BON_CLUB'] : [])] : ['CB', 'BON_CLUB'],
    supplement_personnalisation_centimes: supplementPersonnalisation * quantite + supplementComposants,
    montant_centimes: (prix + selectionOptions.reduce((sum, o) => sum + o.prix_centimes, 0) + supplementPersonnalisation) * quantite + supplementComposants };
}

// Modification locale d'une ligne déjà préparée : aucun stock ni quota n'est écrit.
export function modifierQuantiteLignePanier(panier = [], index, valeur, tailles = []) {
  const quantite = Number(valeur);
  if (!Number.isSafeInteger(quantite) || quantite < 1 || quantite > 999) throw new Error('Choisissez une quantité entière entre 1 et 999.');
  const ligne = panier[index];
  if (!ligne || !Number.isSafeInteger(Number(ligne.quantite)) || Number(ligne.quantite) < 1) throw new Error('Cette ligne de panier ne peut pas être modifiée.');
  const ancienneQuantite = Number(ligne.quantite);
  const articles = (ligne.articles || []).map((article) => {
    const quantiteUnitaire = Number(article.quantite) / ancienneQuantite;
    if (!Number.isSafeInteger(quantiteUnitaire) || quantiteUnitaire < 1) throw new Error('La composition de cette ligne de panier est invalide.');
    const quantiteArticle = quantiteUnitaire * quantite;
    if (!Array.isArray(article.personnalisations_unites)) return { ...article, quantite: quantiteArticle };
    const unitesParLigne = article.personnalisations_unites.length / ancienneQuantite;
    if (!Number.isSafeInteger(unitesParLigne) || unitesParLigne !== quantiteUnitaire) {
      throw new Error('Les saisies de personnalisation de cette ligne sont incomplètes. Modifiez la ligne avant de poursuivre.');
    }
    const modele = article.personnalisations_unites.slice(0, unitesParLigne);
    const personnalisationsUnites = Array.from({ length: quantiteArticle }, (_, index) => {
      const source = modele[index % unitesParLigne] || {};
      return {
        ...source,
        unite:index + 1,
        options:Array.isArray(source.options) ? source.options.map((option) => ({ ...option })) : [],
      };
    });
    return { ...article, quantite:quantiteArticle, personnalisations_unites:personnalisationsUnites };
  });
  articles.forEach((article) => {
    const taille = tailles.find((item) => String(item.id) === String(article.taille_id));
    if (!taille || taille.quota_illimite) return;
    const reserveAutresLignes = panier.flatMap((item, position) => position === index ? [] : (item.articles || []))
      .filter((item) => String(item.taille_id) === String(article.taille_id))
      .reduce((total, item) => total + Number(item.quantite || 0), 0);
    const reserveNouvelleLigne = articles.filter((item) => String(item.taille_id) === String(article.taille_id))
      .reduce((total, item) => total + Number(item.quantite || 0), 0);
    if (!Number.isFinite(Number(taille.quota)) || reserveAutresLignes + reserveNouvelleLigne > Number(taille.quota)) {
      throw new Error(`Quantité indisponible pour ${article.nom}, taille ${article.taille}.`);
    }
  });
  const montantUnitaire = Number(ligne.montant_centimes) / ancienneQuantite;
  if (!Number.isSafeInteger(montantUnitaire) || montantUnitaire < 0) throw new Error('Le montant de cette ligne de panier est invalide.');
  const modifiee = { ...ligne, quantite, articles, montant_centimes: montantUnitaire * quantite };
  return panier.map((item, position) => position === index ? modifiee : item);
}

